import homePage from '@/pages/HomePage'
import loginPage from '@/pages/LoginPage'
import forgotPassword from '@/pages/ForgotPassword'
import resetEmail from '@/pages/ResetEmail'
import resetPassword from '@/pages/ResetPassword'
import studentList from '@/pages/StudentList'
import studentListPayment from '@/pages/StudentListPayment'
import studentCourseList from '@/pages/StudentCourseList'
import student from '@/pages/Student/Student'
import parentList from '@/pages/ParentList'
import parent from '@/pages/Parent'
import manageRelationship from '@/pages/ManageRelationship'
import parentRegister from '@/pages/ParentRegister'
import staffNewsfeed from '@/pages/StaffPost'
import pendingPost from '@/pages/PendingPost'
import attendanceList from '@/pages/AttendanceList'
import AttendanceSubject from '@/pages/AttendanceSubject'
import Academica from '@/pages/academica/Academica'
import backdateAttendance from '@/pages/BackdateAttendance'
import attendanceAuditTrail from '@/pages/AttendanceAuditTrail'
import attendanceMonitoring from '@/pages/iframe/attendanceMonitoring'
import gallery from '@/pages/Gallery'
import promotion from '@/pages/Promotion'
import report from '@/pages/Report'
import notFound from '@/pages/notFound/NotFound'
import dailyRoutine from '@/pages/DailyRoutine'
import dailyRoutine2 from '@/pages/DailyRoutine2'
import dailyRoutineMassUpdate from '@/pages/DailyRoutineMassUpdate'
import pendingApprover from '@/pages/PendingApprover'
import postapprove from '@/pages/PostApprove'
import myAccount from '@/pages/MyAccount'
import myChild from '@/pages/MyChild'
import approvermaster from '@/pages/ApproverMaster'
import transferIn from '@/pages/TransferIn'
import studentgraduation from '@/pages/StudentGraduation'
import classManagement from '@/pages/ClassManagement'
import studentPaymentPlan from '@/pages/StudentPaymentPlan'
import DownloadPreview from '@/pages/download/downloadPreview'
import event from '@/pages/Event'
import eventEmail from '@/pages/EventBlastEmail'
import StaffEventCalendar from '@/pages/StaffEventCalendar'
import eventPublic from '@/pages/Public/PublicEvent'
import busMaster from '@/pages/BusMaster'
import busAttendance from '@/pages/BusAttendance'
import ecaMaster from '@/pages/EcaMaster'
import ecaAttendance from '@/pages/EcaAttendance'
import attendanceReport from '@/pages/AttendanceReport'
import AttendanceICAReport from '@/pages/AttendanceICAReport'
import studentReceiptDetail from '@/pages/StudentReceiptDetail'
import batchPaymentList from '@/pages/BatchPaymentList'
import cancelSchedule from '@/pages/CancelSchedule'
import classAttendanceReport from '@/pages/ClassAttendanceReport'
import dashboardPage from '@/pages/dashboard/dashboardPage'
import dashboardStatePage from '@/pages/dashboard/dashboardStatePage'
import invoiceList from '@/pages/InvoiceList'
import attendanceMaster from '@/pages/AttendanceMaster'
import classOverview from '@/pages/ClassOverview'
import portfolioMedia from '@/pages/PortfolioMedia'
import plannerMaster from '@/pages/PlannerMaster'
import plannerAssignSchool from '@/pages/PlannerAssignSchool'
import PlannerLevel from '@/pages/planner/PlannerLevel'
import plannerAssignLevel from '@/pages/PlannerAssignLevel'
import PlannerLevelAssign from '@/pages/planner/PlannerLevelAssign'
import PlannerClass from '@/pages/planner/PlannerClass'
import PlannerAssignClass from '@/pages/PlannerAssignClass'
import PlannerCloneClass from '@/pages/PlannerCloneClass'
import plannerAssignStudent from '@/pages/PlannerAssignStudent'
import secretAdminConfigPage from '@/pages/SecretAdminConfigPage'
import plannerStudentProgress from '@/pages/PlannerStudentProgress'
import transactionListing from '@/pages/TransactionListing'
import studentListReport from '@/pages/StudentListReport'
import salesLedgerReport from '@/pages/SalesLedgerReport'
import publicPage from '@/pages/Public/PublicPage'
import newFeed from '@/pages/NewFeed'
import newMedia from '@/pages/NewMedia'
import newBroadcast from '@/pages/NewBroadcast'
import newEvent from '@/pages/NewEvent'
import batchItemList from '@/pages/BatchItemList'
import newStudentInfo from '@/pages/NewStudentInfo'
import navigationMaster from '@/pages/NavigationMaster'
import pickupAcknowledgement from '@/pages/PickupAcknowledgement'
import portfolioDetails from '@/pages/PortfolioDetails'
import plannerapprove from '@/pages/PlannerApprove'
import studentSiblingReport from '@/pages/StudentSiblingReport'
import AuthorizedPickupListDetailsReport from '@/pages/AuthorizedPickupListDetailsReport'
import fpsReport from '@/pages/FPSReport'
import fpsReport2 from '@/pages/FPSReport2'
import studentMovementReport from '@/pages/StudentMovementReport'
import travelDeclarationReport from '@/pages/TravelDeclarationReport'
import postPortfolio from '@/pages/PostPortfolio'
import eventPostBack from '@/pages/EventPostBack'
import rebateList from '@/pages/RebateList'
import FeeCalculator from '@/pages/FeeCalculator'
import AgeCalculator from '@/pages/AgeCalculator'
import staffMainPage from '@/pages/StaffMainPage'
import termlyReport from '@/pages/termlyReport/TermlyReport'
import applicationManagement from '@/modules/ApplicationFormManagement/ApplicationManagement.vue'
import applicationList from '@/modules/ApplicationFormManagement/ApplicationList.vue'
import addApplicationQuestion from '@/pages/AddApplicationQuestion'
import withdrawalStatusList from '@/pages/withdrawal/withdrawalStatusListPage'
import withdrawalManagement from '@/pages/withdrawal/withdrawalManagementPage'
import WdfRedirectFromKagami from '@/pages/withdrawal/WdfRedirectFromKagamiPage'
import incidentForm from '@/pages/IncidentForm'
import incidentList from '@/pages/IncidentList'
import agingReport from '@/pages/AgingReport'
import staffScanTemperature from '@/pages/StaffScanTemperature'
import staffScanTemperatureWithStud from '@/pages/StaffScanTemperatureWithStud'
import userManagementForAdmin from '@/pages/UserManagementForAdmin'
import schoolManagementForAdmin from '@/pages/SchoolManagementForAdmin'
import schoolManagementForAdminEdit from '@/pages/SchoolManagementForAdminEdit'
import parentregisterstatusreport from '@/pages/ParentRegisterStatusReport'
import c19declarationreport from '@/pages/C19DeclarationReport'
import attendancelistview from '@/pages/AttendanceListView'
import staffScanTemperatureWithBarCode from '@/pages/StaffScanTemperatureWithBarCode'
import emailCampaign from '@/pages/email/emailCampaign'
import activityJapanPage from '@/pages/activityJapan/activityPage'
import activityPage from '@/pages/activity/activityPage'
import newActivityJapanPage from '@/pages/activityJapan/newActivityPage'
import newActivityPage from '@/pages/activity/newActivityPage'
import activityDownloadPage from '@/pages/activity/activityDownloadPage'
import AlumniReport from '@/pages/alumniReport/alumniReport'
import SchoolFeeReport from '@/pages/SchoolFeeReport/SchoolFeeReport'
import GroupSchoolFeeReport from '@/pages/GroupSchoolFeeReport/GroupSchoolFeeReport'
import StudentAttendanceReport from '@/pages/AttendanceReports/StudentAttendanceReport'
import DailyAttendanceReport from '@/pages/DailyAttendanceReport/DailyAttendanceReport'
import ApfRedirectFromKagami from '@/pages/application/ApfRedirectFromKagami'
import studentMealReport from '@/pages/StudentMealReport'
import studentAdditionalLangReport from '@/pages/StudentAdditionalLangReport'
import FinanceNotification from '@/pages/FinanceNotifcation/FinanceNotification'
import WithdrawEnrolmentReport from '@/pages/WithdrawEnrolmentReport/WithdrawEnrolmentReport'
import AgentTracker from '@/pages/AgentTracker'
import AgencyListSummary from '@/pages/AgencyListSummary'
import AgencyStudentList from '@/pages/AgencyStudentList'
import NewAttendanceReportDaily from '@/pages/NewAttendanceReportDaily'
import NewAttendanceReportMonthly from '@/pages/NewAttendanceReportMonthly'
import SwdaPeiAnnualReturns from '@/pages/SwdaPeiAnnualReturns'
import loginPageParent from '@/pages/LoginPageParent'
import parentRegisterByLink from '@/pages/ParentRegisterByLink'
import password from '@/pages/Protected'
import payment from '@/pages/payment/Payment'
import withdrawForm from '@/pages/WithdrawForm'
import thankYouPage from '@/pages/ThankYouPage'
import travelDeclarationPublic from '@/pages/Public/PublicTravelDeclaration'
import newMyAccount from '@/pages/NewMyAccount'
import thankyouPayment from '@/pages/ThankyouPayment'
import EhStudentApplicationForm from '@/pages/application/EhStudentApplicationForm'
import MisStudentApplicationForm from '@/pages/application/MisStudentApplicationForm'
import PreStudentApplicationForm from '@/pages/application/PreStudentApplicationForm'
import ClayStudentApplicationForm from '@/pages/application/ClayStudentApplicationForm'
import onlineWithdrawalForm from '@/pages/withdrawal/onlineWithdrawalFormPage'
import dailyRoutineParent from '@/pages/DailyRoutineParent'
import RedirectToMobilePost from '@/pages/RedirectToMobilePost'
import ParentNotFoundPage from '@/pages/notFound/parentNotFoundPage'
import AacademicaMedicineFormList from '@/pages/AacademicaMedicineFormList'
import AacademicaMedicineReports from '@/pages/AacademicaMedicineReports'
import EbisStudentApplicationForm from '@/pages/application/EbisStudentApplicationForm.vue'
import TermlyReportPreviousYears from '../pages/TermlyReportPreviousYears.vue'

let isJapan = window.location.host.toUpperCase().includes(process.env.VUE_APP_ROOT_API7.toUpperCase())

function guardMyroute(to, from, next) {
  const isAuthenticated = localStorage.getItem('LoggedUser') === 'true'
  const loggedInAt = localStorage.getItem('LoggedInAt')
  const authCheck = isAuthenticated && loggedInAt && Number(new Date()) - new Date(loggedInAt) < 3600 * 1000
  if (authCheck) {
    next()
  } else {
    next({
      path: '/Public/protected',
      query: {
        ID: to.query.ID,
      },
    })
  }
}

export const staffRoute = [
  {
    path: '/',
    name: 'Home',
    component: homePage,
  },
  {
    path: '/login',
    name: 'Login',
    component: loginPage,
    meta: { bodyClass: 'login' },
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: forgotPassword,
  },
  {
    path: '/reset-email',
    name: 'resetEmail',
    component: resetEmail,
    meta: { bodyClass: 'resetEmail' },
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: resetPassword,
    meta: { bodyClass: 'resetPassword' },
  },
  {
    path: '/student-list',
    name: 'Student List',
    component: studentList,
  },
  {
    path: '/student-list-payment',
    name: 'Student List Payment',
    component: studentListPayment,
  },
  {
    path: '/studentCourse-List',
    name: 'Student Course List',
    component: studentCourseList,
  },
  {
    path: '/student',
    name: 'Student',
    component: student,
  },
  {
    path: '/parent-list',
    name: 'Parent List',
    component: parentList,
  },
  {
    path: '/parent',
    name: 'Parent',
    component: parent,
  },
  {
    path: '/manage-relationship',
    name: 'Manage Relationship',
    component: manageRelationship,
  },
  {
    path: '/register/parent',
    name: 'Parent Registration',
    component: parentRegister,
    meta: { bodyClass: 'parent-register' },
  },
  {
    path: '/Feed',
    name: 'Latest Update',
    component: staffNewsfeed,
  },
  {
    path: '/post/pending',
    name: 'Pending Post',
    component: pendingPost,
  },
  {
    path: '/Attendancelist',
    name: 'Attendance List',
    component: attendanceList,
  },
  {
    path: '/AttendanceSubject',
    name: 'Attendance By Subject',
    component: AttendanceSubject,
  },
  {
    path: '/Academica',
    name: 'Academica',
    component: Academica,
  },
  {
    path: '/Backdateattendance',
    name: 'Backdate Attendance',
    component: backdateAttendance,
  },
  {
    path: '/AttendanceAuditTrail',
    name: 'Attendance Audit Trail',
    component: attendanceAuditTrail,
  },
  {
    path: '/AttendanceMonitoring',
    name: 'Attendance Monitoring',
    component: attendanceMonitoring,
  },
  {
    path: '/Gallery',
    name: 'Gallery',
    component: gallery,
  },
  {
    path: '/promotion',
    name: 'promotion',
    component: promotion,
  },
  {
    path: '/report',
    name: 'report',
    component: report,
  },
  {
    path: '*',
    name: 'Not Found',
    component: notFound,
  },
  {
    path: '/DailyRoutine',
    name: 'Daily Routine',
    component: dailyRoutine,
  },
  {
    path: '/DailyLog',
    name: 'Daily Log',
    component: dailyRoutine2,
  },
  {
    path: '/DailyRoutineMassUpdate',
    name: 'Daily Routine Mass Update',
    component: dailyRoutineMassUpdate,
  },
  {
    path: '/PendingApprover',
    name: 'Pending Approver',
    component: pendingApprover,
  },
  {
    path: '/PostApprove',
    name: 'Post Approve',
    component: postapprove,
  },
  {
    path: '/MyAccount',
    name: 'My Account',
    component: myAccount,
  },
  {
    path: '/MyChild',
    name: 'My Child',
    component: myChild,
  },
  {
    path: '/ApproverMaster',
    name: 'Approver Master',
    component: approvermaster,
  },
  {
    path: '/TransferIn',
    name: 'Transfer In',
    component: transferIn,
  },
  {
    path: '/StudentGraduation',
    name: 'Student Graduation',
    component: studentgraduation,
  },
  {
    path: '/ClassManagement',
    name: 'Class Management',
    component: classManagement,
  },
  {
    path: '/StudentPaymentPlan',
    name: 'Student Payment Plan',
    component: studentPaymentPlan,
  },
  {
    path: '/DownloadPreview',
    name: 'Download Preview',
    component: DownloadPreview,
  },
  {
    path: '/Event',
    name: 'Event',
    component: event,
  },
  {
    path: '/EventEmail',
    name: 'EventEmail',
    component: eventEmail,
  },
  {
    path: '/StaffEventCalendar',
    name: 'StaffEventCalendar',
    component: StaffEventCalendar,
  },
  {
    path: '/public/EventPublic',
    name: 'Event Public Registration',
    component: eventPublic,
  },
  {
    path: '/BusMaster',
    name: 'Bus Master',
    component: busMaster,
  },
  {
    path: '/BusAttendance',
    name: 'Bus Attendance',
    component: busAttendance,
  },
  {
    path: '/EcaMaster',
    name: 'ECA Master',
    component: ecaMaster,
  },
  {
    path: '/EcaAttendance',
    name: 'ECA Attendance',
    component: ecaAttendance,
  },
  {
    path: '/AttendanceReport',
    name: 'Attendance Report',
    component: attendanceReport,
  },
  {
    path: '/AttendanceICAReport',
    name: 'Attendance Report For ICA',
    component: AttendanceICAReport,
  },
  {
    path: '/StudentReceiptDetail',
    name: 'StudentReceiptDetail',
    component: studentReceiptDetail,
  },
  {
    path: '/BatchPaymentList',
    name: 'BatchPaymentList',
    component: batchPaymentList,
  },
  {
    path: '/CancelSchedule',
    name: 'CancelSchedule',
    component: cancelSchedule,
  },
  {
    path: '/ClassAttendanceReport',
    name: 'ClassAttendanceReport',
    component: classAttendanceReport,
  },
  {
    path: '/Dashboard',
    name: 'DashboardPage',
    component: dashboardPage,
  },
  {
    path: '/DashboardState',
    name: 'DashboardStatePage',
    component: dashboardStatePage,
  },
  {
    path: '/InvoiceList',
    name: 'InvoiceLIst',
    component: invoiceList,
  },
  {
    path: '/AttendanceMaster',
    name: 'AttendanceMaster',
    component: attendanceMaster,
  },
  {
    path: '/ClassOverview',
    name: 'ClassOverview',
    component: classOverview,
  },
  {
    path: '/Public/PortfolioMedia',
    name: 'PortfolioMedia',
    component: portfolioMedia,
    meta: { bodyClass: 'portfolioMedia' },
  },
  {
    path: '/PlannerMaster',
    name: 'Planner Master',
    component: plannerMaster,
  },
  {
    path: '/PlannerAssignSchool',
    name: 'Planner Assign School',
    component: plannerAssignSchool,
  },
  {
    path: '/PlannerLevel',
    name: 'Level Goal Planner',
    component: PlannerLevel,
  },
  {
    path: '/PlannerAssignLevel',
    name: 'Level Goal Planner',
    component: plannerAssignLevel,
  },
  {
    path: '/PlannerLevelAssign',
    name: 'Level Goal Planner Assign',
    component: PlannerLevelAssign,
  },
  {
    path: '/PlannerClass',
    name: 'Class Goal Planner',
    component: PlannerClass,
  },
  {
    path: '/PlannerAssignClass',
    name: 'Level Assign Class',
    component: PlannerAssignClass,
  },
  {
    path: '/PlannerCloneClass',
    name: 'Planner Setup Cloning by Class',
    component: PlannerCloneClass,
  },
  {
    path: '/PlannerAssignStudent',
    name: 'Planner Assign Student',
    component: plannerAssignStudent,
  },
  {
    path: '/SecretAdminConfigPage',
    name: 'Secret Admin Config Page',
    component: secretAdminConfigPage,
  },
  {
    path: '/PlannerStudentProgress',
    name: 'Planner Student Progress',
    component: plannerStudentProgress,
  },
  {
    path: '/TransactionListing',
    name: 'TransactionListing',
    component: transactionListing,
  },
  {
    path: '/StudentListReport',
    name: 'Student List Report',
    component: studentListReport,
  },
  {
    path: '/SalesLedgerReport',
    name: 'Sales Ledger Report',
    component: salesLedgerReport,
  },
  {
    path: '/public/public-page',
    name: 'Public Page',
    component: publicPage,
  },
  {
    path: '/NewFeed',
    name: 'New Feed',
    component: newFeed,
  },
  {
    path: '/NewMedia',
    name: 'New Media',
    component: newMedia,
  },
  {
    path: '/NewBroadcast',
    name: 'New Broadcast',
    component: newBroadcast,
  },
  {
    path: '/NewEvent',
    name: 'New Event',
    component: newEvent,
  },
  {
    path: '/BatchItemList',
    name: 'Batch Item List',
    component: batchItemList,
  },
  {
    path: '/NewStudentInfo',
    name: 'New Student Info',
    component: newStudentInfo,
  },
  {
    path: '/NavigationMaster',
    name: 'Navigation Master',
    component: navigationMaster,
  },
  {
    path: '/PickupAcknowledgement',
    name: 'PickupAcknowledgement',
    component: pickupAcknowledgement,
  },
  {
    path: '/Public/PortfolioDetails',
    name: 'Portfolio Details',
    component: portfolioDetails,
  },
  {
    path: '/PlannerApprove',
    name: 'Planner Approve',
    component: plannerapprove,
  },
  {
    path: '/StudentSiblingReport',
    name: 'Student Sibling Report',
    component: studentSiblingReport,
  },
  {
    path: '/FPSReport',
    name: 'FPS Report',
    component: fpsReport,
  },
  {
    path: '/FPSReport2',
    name: 'FPS Report New Format',
    component: fpsReport2,
  },
  {
    path: '/StudentMovementReport',
    name: 'Student Movement Report',
    component: studentMovementReport,
  },
  {
    path: '/travelDeclarationReport',
    name: 'travelDeclarationReport',
    component: travelDeclarationReport,
    meta: { bodyClass: 'travelDeclarationReport' },
  },
  {
    path: '/PostPortfolio',
    name: 'Post Portfolio',
    component: postPortfolio,
  },
  {
    path: '/EventPostBack',
    name: 'EventPostBack',
    component: eventPostBack,
  },
  {
    path: '/RebateList',
    name: 'RebateList',
    component: rebateList,
  },
  {
    path: '/FeeCalculator',
    name: 'FeeCalculator',
    component: FeeCalculator,
  },
  {
    path: '/AgeCalculator',
    name: 'AgeCalculator',
    component: AgeCalculator,
  },
  {
    path: '/StaffMainPage',
    name: 'StaffMainPage',
    component: staffMainPage,
    meta: { bodyClass: 'staffMainPage' },
  },
  {
    path: '/TermlyReport',
    name: 'TermlyReport',
    component: termlyReport,
  },
  {
    path: '/TermlyReportHistory',
    name: 'TermlyReportPreviousYears',
    component: TermlyReportPreviousYears,
  },
  {
    path: '/ApplicationManagement',
    name: 'ApplicationManagement',
    component: applicationManagement,
  },
  {
    path: '/ApplicationList',
    name: 'ApplicationList',
    component: applicationList,
  },
  {
    path: '/AddApplicationQuestion',
    name: 'AddApplicationQuestion',
    component: addApplicationQuestion,
  },
  {
    path: '/WithdrawalList',
    name: 'WithdrawalList',
    component: withdrawalStatusList,
  },
  {
    path: '/WithdrawalManagement',
    name: 'WithdrawalManagement',
    component: withdrawalManagement,
  },
  {
    path: '/WithdrawalForm',
    component: WdfRedirectFromKagami,
  },
  {
    path: '/IncidentForm',
    name: 'IncidentForm',
    component: incidentForm,
  },
  {
    path: '/IncidentList',
    name: 'IncidentList',
    component: incidentList,
  },
  {
    path: '/AgingReport',
    name: 'AgingReport',
    component: agingReport,
  },
  {
    path: '/StaffScanTemperature',
    name: 'StaffScanTemperature',
    component: staffScanTemperature,
  },
  {
    path: '/StaffScanTemperatureWithStud',
    name: 'StaffScanTemperatureWithStud',
    component: staffScanTemperatureWithStud,
  },
  {
    path: '/UserManagementForAdmin',
    name: 'UserManagementForAdmin',
    component: userManagementForAdmin,
  },
  {
    path: '/SchoolManagementForAdmin',
    name: 'SchoolManagementForAdmin',
    component: schoolManagementForAdmin,
  },
  {
    path: '/SchoolManagementForAdminEdit',
    name: 'SchoolManagementForAdminEdit',
    component: schoolManagementForAdminEdit,
  },
  {
    path: '/ParentRegisterStatusReport',
    name: 'ParentRegisterStatusReport',
    component: parentregisterstatusreport,
  },
  {
    path: '/C19DeclarationReport',
    name: 'C19DeclarationReport',
    component: c19declarationreport,
  },
  {
    path: '/AttendanceListView',
    name: 'AttendanceListView',
    component: attendancelistview,
  },
  {
    path: '/StaffScanTemperatureWithBarCode',
    name: 'StaffScanTemperatureWithBarCode',
    component: staffScanTemperatureWithBarCode,
  },
  {
    path: '/EmailCampaign',
    name: 'EmailCampaign',
    component: emailCampaign,
  },
  {
    path: '/Activity',
    name: 'ActivityPage',
    component: isJapan ? activityJapanPage : activityPage,
  },
  {
    path: '/NewActivity',
    name: 'NewActivityPage',
    component: isJapan ? newActivityJapanPage : newActivityPage,
    props: true,
  },
  {
    path: '/ActivityDownload',
    name: 'ActivityDownload',
    component: activityDownloadPage,
    props: true,
  },
  {
    path: '/alumniReport',
    name: 'AlumniReport',
    component: AlumniReport,
  },
  {
    path: '/SchoolFeeReport',
    name: 'SchoolFeeReport',
    component: SchoolFeeReport,
  },
  {
    path: '/GroupSchoolFeeReport',
    name: 'GroupSchoolFeeReport',
    component: GroupSchoolFeeReport,
  },
  {
    path: '/StudentAttendanceReport',
    name: 'StudentAttendanceReport',
    component: StudentAttendanceReport,
    props: true,
  },
  {
    path: '/DailyAttendanceReport',
    name: 'DailyAttendanceReport',
    component: DailyAttendanceReport,
    props: true,
  },
  {
    path: '/ApplicationForm',
    component: ApfRedirectFromKagami,
  },
  {
    path: '/StudentMealReport',
    name: 'Student Meal Report',
    component: studentMealReport,
  },
  {
    path: '/StudentAdditionalLangReport',
    name: 'Student Add Language Report',
    component: studentAdditionalLangReport,
  },
  {
    path: '/FinanceNotification',
    name: 'FinanceNotification',
    component: FinanceNotification,
    props: true,
  },
  {
    path: '/ApplicationForm',
    component: ApfRedirectFromKagami,
  },
  {
    path: '/StudentMealReport',
    name: 'Student Meal Report',
    component: studentMealReport,
  },
  {
    path: '/StudentAdditionalLangReport',
    name: 'Student Add Language Report',
    component: studentAdditionalLangReport,
  },
  {
    path: '/FinanceNotification',
    name: 'FinanceNotification',
    component: FinanceNotification,
    props: true,
  },
  {
    path: '/WithdrawEnrolmentReport',
    name: 'WithdrawEnrolmentReport',
    component: WithdrawEnrolmentReport,
    props: true,
  },
  {
    path: '/AgentTracker',
    name: 'AgentTracker',
    component: AgentTracker,
  },
  {
    path: '/AgencyListSummary',
    name: 'AgencyListSummary',
    component: AgencyListSummary,
  },
  {
    path: '/AgencyStudentList',
    name: 'AgencyStudentList',
    component: AgencyStudentList,
  },
  {
    path: '/NewAttendanceReportDaily',
    name: 'NewAttendanceReportDaily',
    component: NewAttendanceReportDaily,
  },
  {
    path: '/NewAttendanceReportMonthly',
    name: 'NewAttendanceReportMonthly',
    component: NewAttendanceReportMonthly,
  },
  {
    path: '/SwdaPeiAnnualReturns',
    name: 'SwdaPeiAnnualReturns',
    component: SwdaPeiAnnualReturns,
    // only Orchard & Broadrick schools can access this report
    meta: { requiresPeiAnnualReturnsAccess: true },
  },
  {
    path: '/MedicineFormList',
    name: 'AacademicaMedicineFormList',
    component: AacademicaMedicineFormList,
    // only allowed schools can access this page
    meta: { requiresMedicineMenuAccess: true },
  },
  {
    path: '/MedicineReports',
    name: 'AacademicaMedicineReports',
    component: AacademicaMedicineReports,
    // only allowed schools can access this page
    meta: { requiresMedicineMenuAccess: true },
  },
]

export const parentRoute = [
  {
    path: '/NewFeed',
    name: 'NewFeed',
    component: newFeed,
  },
  {
    path: '/login',
    name: 'Login',
    component: loginPageParent,
    meta: { bodyClass: 'login' },
  },
  {
    path: '/Academica',
    name: 'Academica',
    component: Academica,
  },
  {
    path: '/NewBroadcast',
    name: 'New Broadcast',
    component: newBroadcast,
  },
  {
    path: '/NewEvent',
    name: 'New Event',
    component: newEvent,
  },
  {
    path: '/ParentRegisterByLink',
    name: 'ParentRegisterByLink',
    component: parentRegisterByLink,
    meta: { bodyClass: 'parent-register' },
  },
  {
    path: '/reset-email',
    name: 'resetEmail',
    component: resetEmail,
    meta: { bodyClass: 'resetEmail' },
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: resetPassword,
    meta: { bodyClass: 'resetPassword' },
  },
  {
    path: '/Public/protected',
    name: 'protetected',
    component: password,
  },
  {
    path: '/Public/Payment/',
    name: 'Payment',
    component: payment,
    beforeEnter: guardMyroute,
  },
  {
    path: '/Public/WithdrawForm',
    name: 'WithdrawForm',
    component: withdrawForm,
    meta: { bodyClass: 'WithdrawForm' },
  },
  {
    path: '/Public/ThankYouPage',
    name: 'ThankYouPage',
    component: thankYouPage,
    meta: { bodyClass: 'thankYouPage' },
  },
  {
    path: '/TravelDeclaration',
    name: 'TravelDeclaration',
    component: travelDeclarationPublic,
    meta: { bodyClass: 'travelDeclarationPublic' }, //travelDeclarationReport
  },
  {
    path: '/',
    redirect: { name: 'StaffMainPage' },
  },
  {
    path: '/StaffMainPage',
    name: 'StaffMainPage',
    component: staffMainPage,
    meta: { bodyClass: 'staffMainPage' },
  },
  {
    path: '/NewMyAccount',
    name: 'New My Account',
    component: newMyAccount,
    meta: { bodyClass: 'newMyAccount' },
  },
  {
    path: '/Public/ThankyouPayment',
    name: 'ThankyouPayment',
    component: thankyouPayment,
    meta: { bodyClass: 'thankyouPayment' },
  },
  {
    path: '/Public/StudentApplicationForm',
    name: 'EhStudentApplicationForm',
    component: EhStudentApplicationForm,
    meta: { bodyClass: 'application-form' },
  },
  {
    path: '/Public/MisStudentApplicationForm',
    name: 'MisStudentApplicationForm',
    component: MisStudentApplicationForm,
    meta: { bodyClass: 'application-form' },
  },
  {
    path: '/Public/PreschoolStudentApplicationForm',
    name: 'PreschoolStudentApplicationForm',
    component: PreStudentApplicationForm,
    meta: { bodyClass: 'application-form' },
  },
  {
    path: '/Public/StudentApplicationForm_Claymore',
    name: 'ClayStudentApplicationForm',
    component: ClayStudentApplicationForm,
    meta: { bodyClass: 'application-form' },
  },
  {
    path: '/Public/EbisStudentApplicationForm',
    name: 'EbisStudentApplicationForm',
    // component: () => import('@/pages/application/EbisStudentApplicationForm.vue'),
    component: EbisStudentApplicationForm,
    meta: { bodyClass: 'application-form' },
  },
  {
    path: '/Public/OnlineWithdrawalForm',
    name: 'OnlineWithdrawalForm',
    component: onlineWithdrawalForm,
    meta: { bodyClass: 'application-form' },
  },
  {
    path: '/DailyRoutine',
    name: 'Daily Routine',
    component: dailyRoutineParent,
  },
  {
    path: '/ActivityDownload',
    name: 'ActivityDownload',
    component: activityDownloadPage,
    props: true,
  },
  {
    path: '/AuthorizedPickupListDetailsReport',
    name: 'Authorized Pickup List Details Report',
    component: AuthorizedPickupListDetailsReport,
    // Orchard, Broadrick, Middleton Tampines and other countries (Japan, Bhutan) are excluded from this report
    meta: { requiresAuthorizedPickupListDetailsAccess: true },
  },
  {
    path: '/public/posts/:id',
    name: 'RedirectToMobilePost',
    component: RedirectToMobilePost,
    props: true,
  },
  {
    path: '*',
    name: 'Not Found',
    component: ParentNotFoundPage,
  },
  {
    path: '/app',
    name: 'App',
    component: ParentNotFoundPage,
  },
]
